import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Fade } from "./Fade";

export function Hero() {
  return (
    <section className="relative pt-32 sm:pt-40 pb-20 sm:pb-28 px-5 sm:px-8 md:px-10 overflow-hidden">
      {/* Subtle ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-[hsl(217_91%_60%)] opacity-[0.06] blur-[160px] pointer-events-none" />

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <Fade>
          <p className="text-xs tracking-[0.2em] uppercase text-[hsl(217_91%_60%)] mb-6 font-medium">
            Campaign orchestration · Embedded capital · Growth Advisor
          </p>
        </Fade>

        <Fade delay={0.05}>
          <h1 className="font-bold leading-[1.05] tracking-[-0.03em] max-w-3xl" style={{ fontSize: "clamp(2.2rem, 5.5vw, 4.2rem)" }}>
            The growth platform that funds your best campaigns
          </h1>
        </Fade>

        <Fade delay={0.1}>
          <p className="text-white/45 text-base sm:text-lg leading-relaxed max-w-xl mt-6">
            Growth Lever combines multi-channel campaign management, embedded co-investment capital,
            and a data-driven Growth Advisor into one execution layer — so performance marketers can scale what's
            working, instantly.
          </p>
        </Fade>

        <Fade delay={0.15} className="mt-8">
          <div className="flex flex-wrap items-center gap-4">
            <Link
              to="/auth?tab=signup"
              className="inline-flex items-center gap-2 bg-white text-black font-semibold text-sm px-7 py-3 rounded-full hover:bg-white/90 transition-colors"
            >
              Start free <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-white font-semibold text-sm bg-[hsl(217_91%_60%)] px-7 py-3 rounded-full hover:bg-[hsl(217_91%_65%)] transition-colors"
            >
              Book a demo
            </Link>
          </div>
        </Fade>

        {/* Product screenshot */}
        <Fade delay={0.25} y={24} className="mt-16">
          <div className="border border-white/10 rounded-lg overflow-hidden bg-white/[0.02] shadow-2xl shadow-black/40">
            <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-white/[0.06] bg-white/[0.02]">
              <div className="h-2 w-2 rounded-full bg-white/10" />
              <div className="h-2 w-2 rounded-full bg-white/10" />
              <div className="h-2 w-2 rounded-full bg-white/10" />
              <span className="ml-3 text-[11px] text-white/20">Growth Lever — Dashboard</span>
            </div>
            <div className="relative aspect-[16/9] bg-[hsl(222_47%_8%)] flex items-center justify-center">
              <img
                src="/screenshots/dashboard.png"
                alt="Growth Lever campaign dashboard"
                className="w-full h-full object-cover"
                loading="eager"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.innerHTML = '<div class="flex items-center justify-center h-full text-white/15 text-sm">Product screenshot coming soon</div>';
                }}
              />
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
